import { useRef } from 'react'
import useHubSpotGenerate from 'hooks/useHubSpotGenerate'
import styles from './Contact.module.scss'
import animationStyles from 'components/common/Animation/Animation.module.scss'
import useElementVisible from 'components/common/Animation/useElementVisible'

type Props = {
  formId: string
}

export const Contact: React.FC<Props> = ({ formId }) => {
  const animeRef = useRef<HTMLDivElement>(null)
  const isVisible = useElementVisible(animeRef, 0.1)

  useHubSpotGenerate('na1', '9395227', `${formId}`, '#sp_hbspt')

  return (
    <section
      className={`${styles.contact} ${animationStyles.fade} ${isVisible ? animationStyles.fadeOn : ''}`}
      ref={animeRef}
    >
      <div className={styles.inner}>
        <p className={styles.push}>ZEBRAでプッシュ通知に関するお悩みを解決しましょう！</p>
        <div className={styles.contactForm}>
          <h2 className={styles.contactForm__title}>お問い合わせ</h2>
          <div className={styles.contactForm__input}>
            <p className={styles.contactForm__input__attention}>※ 全ての項目をご入力ください。</p>
            <div className={styles.hubSpot} id="sp_hbspt"></div>
          </div>
        </div>
      </div>
    </section>
  )
}
